import React from 'react';

import Noise from '../../components/Noise';

import styles from './style.css';

const NotFound = ({ staticContext }) => {
  if (staticContext) staticContext.status = 404; // eslint-disable-line

  return (
    <div className={styles.not__found}>
      <Noise />
      huh?
    </div>
  );
};

export default NotFound;
